import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import { CreateNotification } from "../apiconfig/authService";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
// import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
// import * as React from 'react';
// import { useState, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { toast } from "react-toastify";
import { RiLoaderFill } from "react-icons/ri";
function Addnotification(props) {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
    if (isExpired) navigate("/");

    const setMediaTableViewMessage = props.setMessage;

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [dateTime, setDateTime] = useState("");
    const [message, setMessage] = useState("");
    const [isMessageRed, setIsMessageRed] = useState("");
    const [value, setValue] = React.useState(dayjs());
    const [loading, setLoading] = useState(false);
    const handleTitleChange = (e) => {
        setTitle(e.target.value);
    };
    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };
    const handledatetimeChange = (e) => {
        setDateTime(e.target.value); // Store as UTC
    };


    const handleSubmitClick = async (e) => {
        e.preventDefault();
    
        try {
            if (!title.trim()) {
              toast.error("Title is required!");
              return;
            }
            if (!description.trim()) {
              toast.error("Description is required!");
              return;
          }
          const now = dayjs();
          const minAllowed = now.add(5, "minute");
          if (value.isBefore(minAllowed)) {
             toast.error(
               "The scheduled time must be at least 5 minutes from the current time."
             );
            return;
          }
        } catch (error) {
            toast.error(error.message);
            window.scrollTo(0, 0);
            return;
        }

        let response;
        const data = {
            "title": title,
            "description": description,
            "selecteddate": value,
        }
        try {
            setLoading(true);
            response = await CreateNotification(
                data,
                localStorage.getItem("accessToken")
            );
            if (response.status === 200) {
                setLoading(false);
                toast.success("Notification Added Successfully");
                setMediaTableViewMessage(response.data.message);
                navigate("/notification");
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.error) {
                setLoading(false);
                toast.error(err.response.data.error);
                window.scrollTo(0, 0);
            } else {
                toast.error("An error occurred. Please try again later.");
                window.scrollTo(0, 0);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (newValue) => {
        const now = dayjs();
        if (newValue && newValue.isBefore(now)) {
            // Ignore or optionally correct to now
            setValue(now);
        } else {
            setValue(newValue);
        }
    };

    const disablePastTime = (date) => {
        const now = dayjs();
        // Disable if date is before now
        return date.isBefore(now);
    };

    return (
      <div className="dashboard-content">
        <Sidebar />
        {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
        <div className="body-cart tab-content dasContent p-4 bg-white rounded">
          <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
            <h1 className="heading h4 mb-0 fw-bold">Add Notification</h1>
            <div className="d-inline-flex gap-2">
              <NavLink to="/media" className="btn btn-primary">
                View All
              </NavLink>
            </div>
          </div>
          <div
            role="tabpanel"
            className="personal-info tab-pane active storetab"
            id="pi"
          >
            {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
            <div className="row">
              <div className="form-group col-sm-12 col-lg-12 mb-3">
                <div className="d-flex">
                  <label htmlFor="catName">Title</label>
                  <FaStar size={7} className="text-danger" />
                </div>
                <input
                  type="text"
                  value={title}
                  onChange={handleTitleChange}
                  className="form-control custom-input my-2"
                  id="catName"
                  placeholder="Title"
                />
              </div>
            </div>

            {/* <label htmlFor="floatingInput">Description</label> */}
            <div className="row">
              <div className="form-group col-sm-12 col-lg-12 mb-3">
                <div className="d-flex">
                  <label htmlFor="catName">Description</label>
                  <FaStar size={7} className="text-danger" />
                </div>
                <input
                  type="text"
                  value={description}
                  onChange={handleDescriptionChange}
                  className="form-control custom-input my-2"
                  id="catName"
                  placeholder="Description"
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group col-sm-12 col-lg-12 mb-3">
                <div className="d-flex">
                  <label htmlFor="catName">Date & Time</label>
                  <FaStar size={7} className="text-danger" />
                </div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    // label="Date & Time (no past)"
                    value={value}
                    className="form-control custom-input my-2"
                    onChange={handleChange}
                    minDateTime={dayjs()}
                    shouldDisableTime={(timeValue, clockType) => {
                      const now = dayjs();
                      if (clockType === "hours") {
                        return (
                          value.isSame(now, "day") && timeValue < now.hour()
                        );
                      }
                      if (clockType === "minutes") {
                        return (
                          value.isSame(now, "day") &&
                          value.hour() === now.hour() &&
                          timeValue < now.minute()
                        );
                      }
                      return false;
                    }}
                    disablePast
                  />
                </LocalizationProvider>
              </div>
            </div>

            <div className="row">
              <div className="col-12" style={{ height: "40px", width: "80px" }}>
                {loading ? (
                  <div
                    className="btn btn-primary loader-active save-btn text-uppercase"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <RiLoaderFill
                      size={20}
                      className="spin-animation"
                      color="white"
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    onClick={handleSubmitClick}
                    disabled={loading}
                    className="btn btn-primary save-btn text-uppercase"
                    style={{ height: "100%", width: "100%" }}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    );
}

export default Addnotification;
